"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogFooter = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const create_use_styles_1 = __importDefault(require("../../theming/create-use-styles"));
const useStyles = (0, create_use_styles_1.default)({
    footer: {
        position: "sticky",
        bottom: 0,
        backgroundColor: "inherit",
    },
});
exports.DialogFooter = react_1.default.forwardRef(function DialogFooter({ className, ...props }, ref) {
    const classes = useStyles();
    return react_1.default.createElement("div", { ref: ref, className: (0, classnames_1.default)(classes.footer, className), ...props });
});
exports.default = exports.DialogFooter;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlhbG9nLWZvb3Rlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2NvbXBvbmVudHMvZGlhbG9nL2RpYWxvZy1mb290ZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGtEQUEwQjtBQUMxQiw0REFBb0M7QUFFcEMsd0ZBQThEO0FBSzlELE1BQU0sU0FBUyxHQUFHLElBQUEsMkJBQWUsRUFBQztJQUNoQyxNQUFNLEVBQUU7UUFDTixRQUFRLEVBQUUsUUFBUTtRQUNsQixNQUFNLEVBQUUsQ0FBQztRQUNULGVBQWUsRUFBRSxTQUFTO0tBQzNCO0NBQ0YsQ0FBQyxDQUFDO0FBRVUsUUFBQSxZQUFZLEdBQUcsZUFBSyxDQUFDLFVBQVUsQ0FBb0MsU0FBUyxZQUFZLENBQUMsRUFBRSxTQUFTLEVBQUUsR0FBRyxLQUFLLEVBQUUsRUFBRSxHQUFHO0lBQ2hJLE1BQU0sT0FBTyxHQUFHLFNBQVMsRUFBRSxDQUFDO0lBRTVCLE9BQU8sdUNBQUssR0FBRyxFQUFFLEdBQUcsRUFBRSxTQUFTLEVBQUUsSUFBQSxvQkFBVSxFQUFDLE9BQU8sQ0FBQyxNQUFNLEVBQUUsU0FBUyxDQUFDLEtBQU0sS0FBSyxHQUFJLENBQUM7QUFDeEYsQ0FBQyxDQUFDLENBQUM7QUFFSCxrQkFBZSxvQkFBWSxDQUFDIn0=